import { FunctionComponent } from "react";
import { useTranslation } from "next-i18next/pages";
import styles from "../../styles/home/PainPoints.module.css";

interface PainPointItem {
  title: string;
  text: string;
}

interface PainPointsProps {}

const PainPoints: FunctionComponent<PainPointsProps> = () => {
  const { t } = useTranslation("common");
  const items: PainPointItem[] = t("homeModern.painPoints.items", {
    returnObjects: true
  }) as PainPointItem[];
  const outcomes: string[] = t("homeModern.painPoints.outcomes", {
    returnObjects: true
  }) as string[];

  return (
    <>
      <section id="pain-points" className={styles.section}>
        <div className={styles.statement}>
          <div className={styles.kicker}>{t("homeModern.painPoints.kicker")}</div>
          <div>
            <h2 className={styles.title}>
              {t("homeModern.painPoints.titleLead")}{" "}
              <span>{t("homeModern.painPoints.titleAccent")}</span>
            </h2>
            <p className={styles.description}>
              {t("homeModern.painPoints.description")}
            </p>
          </div>
        </div>

        <div className={styles.grid}>
          {items.map((item: PainPointItem, index: number) => (
            <article key={item.title} className={styles.card}>
              <div className={styles.cardIndex}>0{index + 1} / {item.title.split(" ")[0]}</div>
              <div>
                <h3 className={styles.cardTitle}>{item.title}</h3>
                <p className={styles.cardText}>{item.text}</p>
              </div>
            </article>
          ))}
        </div>

        <div className={styles.outcomePanel}>
          <div>
            <div className={styles.panelKicker}>
              {t("homeModern.painPoints.outcomeKicker")}
            </div>
            <h3 className={styles.panelTitle}>
              {t("homeModern.painPoints.outcomeTitle")}
            </h3>
          </div>
          <a className={styles.panelLink} href="#solutions">
            {t("homeModern.painPoints.cta")} <span aria-hidden="true">→</span>
          </a>
        </div>
      </section>

      <div className={styles.ticker} aria-hidden="true">
        <div className={styles.track}>
          <div className={styles.group}>
            {outcomes.map((outcome: string) => (
              <span key={outcome}>{outcome}<b /></span>
            ))}
          </div>
          <div className={styles.group}>
            {outcomes.map((outcome: string) => (
              <span key={outcome}>{outcome}<b /></span>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default PainPoints;
